import { ComponentType } from '@angular/cdk/portal';
import {
  AutoRenewConfirmationDialogComponent,
  AutoRenewConfirmationDialogData
} from './dialogs/auto-renew-confirmtion/auto-renew-confirmation.dialog';
import {
  CancelationInProgressDialogComponent,
  CancelationInProgressDialogData
} from './dialogs/cancellation-in-progress/cancellation-in-progress.dialog';
import {
  CancellationRequestDialogComponent,
  CancellationRequestDialogData
} from './dialogs/cancellation-request/cancellation-request.dialog';

export const CANCELLATION_IN_PROGRESS_KEY = 'cancellationInProgress';

export enum Countries {
  UNITED_STATES = 'us',
  MEXICO = 'mx',
  PERU = 'pe',
}

export const AUTO_RENEW_UPDATE_COUNTRIES = [

];

export enum Flows {
  AUTO_RENEW_UPDATE,
  CANCELLATION_IN_PROGRESS,
  CANCELLATION_REQUEST
}

export const FLOWS_DIALOGS: {
  [key: number]: ComponentType<
    AutoRenewConfirmationDialogComponent
    | CancelationInProgressDialogComponent
    | CancellationRequestDialogComponent>
  } = {
  [Flows.AUTO_RENEW_UPDATE]: AutoRenewConfirmationDialogComponent,
  [Flows.CANCELLATION_IN_PROGRESS]: CancelationInProgressDialogComponent,
  [Flows.CANCELLATION_REQUEST]: CancellationRequestDialogComponent
};

export const FLOWS_TRANSLATIONS = {
  [Flows.AUTO_RENEW_UPDATE]: {
    title: 'rate_plan.auto_renew_modal.title',
    description: 'rate_plan.auto_renew_modal.description',
    confirm: 'rate_plan.auto_renew_modal.confirm',
    cancel: 'rate_plan.auto_renew_modal.cancel',
  },
  [Flows.CANCELLATION_IN_PROGRESS]: {
    title: 'rate_plan.cancellation_in_progress_modal.title',
    description: 'rate_plan.cancellation_in_progress_modal.description'
  },
  [Flows.CANCELLATION_REQUEST]: {
    title: 'rate_plan.cancellation_request_modal.title',
    description: 'rate_plan.cancellation_request_modal.description',
    phone: 'rate_plan.cancellation_request_modal.phone',
    confirm: 'rate_plan.cancellation_request_modal.confirm',
    editNumber: 'rate_plan.cancellation_request_modal.edit_number',
    confirmationTitle: 'rate_plan.cancellation_request_modal_confirmation.title',
    confirmationDescription: 'rate_plan.cancellation_request_modal_confirmation.description',
    confirmationClose: 'rate_plan.cancellation_request_modal_confirmation.close'
  }
};

export const DIALOG_CONFIG = {
  disableClose: true,
  autoFocus: false
};

export type DataType = Partial<
  AutoRenewConfirmationDialogData
  | CancellationRequestDialogData
  | CancelationInProgressDialogData
>;
